import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import styles from "./AddAttachmentStyles.module.css";
import "../AdvanceFilters/AFModalsStyles.css";
import { useDispatch, useSelector } from "react-redux";
import { detectDomain, fetchUsers, submitQuestion } from "../../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { useNavigate } from "react-router-dom";
import Button from "../../../NewComponent/Button/Button";
import { ModalHeader } from "../../../Constants";


export function AddAttachment() {
  const [value, setValue] = useState(""); 
  const modalState = useSelector((state) => state.domain);
  const editorState = useSelector((state) => state.editor);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, showNoShowConfetti } = bindActionCreators(
    Actions,
    dispatch
  );

  const addCaptionInPayload = () =>{
    editorState.attachments[editorState.attachments.length-1].caption = value;
    advanceFilterModalToggle({ bool: false, value: "" })
  }
  useEffect(() => {
  }, []);
  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
        centered={true}
        size={"md"}
      >
        <Modal.Header
          closeButton
        >
          <Modal.Title style={ModalHeader.styles}>
            <i className="fa fa-paperclip"></i>&nbsp;&nbsp;&nbsp;Add caption for attachment
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12 col-lg-12">
            <input value={value} className="form-control" onChange={(e)=>setValue(e.target.value)} type="text" style={{width:'100%'}}/>            
            <div
              className="form-check mt-2"
              style={{ display: "flex", justifyContent:'center' }}
            >
              <div>
                {/* <button
                  className={`${styles.shareSubmitButtonASK} btn btn-primary`}
                  onClick={()=>addCaptionInPayload()}
                >
                  Add
                </button> */}
                <Button type={'primary'} text={'Add'} onClickFunc={()=>addCaptionInPayload()} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
